import BaseSelectionType from "./BaseSelectionType";
import SelectedData from "./model/SelectedData";

export default class DateSelectionType extends BaseSelectionType{
    accept(visitor, selectedRegion)
    {
        return visitor.visitDateSelection(selectedRegion);
    }

    getSelectedData(lockTable, selectedRegion)
    {
        return new SelectedData(this.getSelectionDateRange(lockTable.getDatesRow(), selectedRegion), null);
    }

    canBeLocked(lockTable, selectedRegion)
    {
        let datesRow = lockTable.getDatesRow();
        for (let colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++)
        {
            if (datesRow.getCell(colIdx).getValue().hasUnlockedInvisibleUser)
                return true;
        }

        let userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
        for (let i = 0; i < userRows.length; i++)
        {
            let row = userRows[i];
            for (let colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++)
            {
                if (!row.getCell(colIdx).getValue().locked)
                    return true;
            }
        }
        return false;
    }

    canBeUnlocked(lockTable, selectedRegion)
    {
        let datesRow = lockTable.getDatesRow();
        for (let colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++)
        {
            if (datesRow.getCell(colIdx).getValue().hasLockedInvisibleUser)
                return true;
        }

        let userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
        for (let i = 0; i < userRows.length; i++)
        {
            let row = userRows[i];
            for (let colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++)
            {
                if (row.getCell(colIdx).getValue().locked)
                    return true;
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/DateSelectionType.js